import axios from "axios";

export default class Surveys {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
    // this.API_LINK = 'http://localhost:8016';
  }

  async getAllSurveys(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/getSurveysAll`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getAllSurveyTypes() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/surveys/questionTypes`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteQuestion(id) {
    try {
      const response = await axios({
        method: "delete",
        url: `${this.API_LINK}/questions/delete/${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async createSurvey(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async createQuestion(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/newQuestion`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async createAnswer(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/newAnswer`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async inactiveSurvey(id) {
    try {
      const response = await axios({
        method: "delete",
        url: `${this.API_LINK}/surveys/deleteSurvey/${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getSurveyById(id) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/surveys/getSurvey/${id}?cms=true`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async editSurvey(params) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/surveys/editSurvey`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getSurveyStats(id, queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/statsSurvey/${id}`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async sendNotification(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/sendPush`,
        headers: {
          'Accept-Language': "es"
        },
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async cloneSurvey(id) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
